export const RESET_PASSWORD_TOKEN_COOKIE = 'resetPasswordToken';
export const RESET_PASSWORD_CODE_COOKIE = 'resetPasswordSmsCode';
export const RESET_PASSWORD_SMS_ADDRESS_COOKIE = 'resetPasswordSmsAddress';

// exported so it can be used client-side in src/routes.js and server-side in lib/server.common.js
export const RESET_PASSWORD_PATH = '/reset_password';
